<template>
  <CardTypeNum :card-type="cardType" :expiring-soon-tip="expiringSoonTip" :residue-number="residueNumber" :expire-number="expireNumber">
    <p class="tip-txt">
      <a-icon class="tip-icon" type="exclamation-circle" />&nbsp;名额不足或管理员未审核，不影响建组，但学生无法上课
    </p>
  </CardTypeNum>
</template>
<script>
import CardTypeNum from '@/components/CardTypeNum.vue'
import cardquity from '@/service/cardquity/index'
export default {
  components: {
    CardTypeNum
  },
  props: {
    courseInfo: Object
  },
  data() {
    return {
      cardType: null,
      residueNumber: null,
      expireNumber: null,
      expiringSoonTip: null
    }
  },
  watch: {
    courseInfo: {
      immediate: true,
      deep: true,
      handler(val) {
        console.log('>>>>>courseInfo 改变', val)
        // 先清除提示
        this.cardType = null
        if (!val) {
          return
        }
        // 只有长线非体验课才显示A B包
        // cardType val
        const { classStyle, experience } = val
        if (classStyle === 1 && experience === 0) {
          // 请求后端接口 获取体验包信息
          this.getQuota()
        }
      }
    }
  },
  methods: {
    async getQuota() {
      const { cardType } = this.courseInfo
      const res = await cardquity.getInsQuota({ cardType: [cardType] })
      if (res.length) {
        const { residueNumber, expireNumber, expiringSoonTip } = res[0]
        this.cardType = cardType
        this.residueNumber = residueNumber
        this.expiringSoonTip = expiringSoonTip
        this.expireNumber = expireNumber
      }
    }
  }
}
</script>
<style lang="less" scoped>
.tip-txt {
  font-size: 12px;
  color: #98A2B2;
  margin-top: 18px;
}
</style>
<style>
.expiring-soon-tip {
  margin-left: 22px;
}
</style>